import { useState, useCallback } from 'react';
import axios from 'axios';
import { FilterOptions } from '../types';
import { API_BASE } from '../constants';

export interface FilterOptionsState {
  filterOptions: FilterOptions;
  filterOptionsLoading: boolean;
  fetchFilterOptions: () => Promise<void>;
}

const DEFAULT_OPTIONS: FilterOptions = {
  pharmacies: [],
  categories: [],
  managers: [],
  products: [],
  serials: [],
  producers: [],
  priceGroups: [],
};

/**
 * Загружает доступные значения для dropdown-фильтров журнала.
 * Поддерживает каскадную фильтрацию:
 *   - список товаров/серий фильтруется по выбранной аптеке
 *   - список производителей и ценовых групп фильтруется по аптеке + выбранному товару
 * username читается из localStorage и передаётся на бэкенд для ограничения вариантов
 * только аптеками, привязанными к пользователю.
 */
export function useFilterOptions(
  selectedMonth: string,
  selectedPharmacy: string | null,
  selectedProduct: string | null,
): FilterOptionsState {
  const [filterOptions, setFilterOptions] = useState<FilterOptions>(DEFAULT_OPTIONS);
  const [filterOptionsLoading, setFilterOptionsLoading] = useState(false);

  const fetchFilterOptions = useCallback(async () => {
    setFilterOptionsLoading(true);
    // username передаётся на бэкенд для фильтрации вариантов по привязанным аптекам
    const username = localStorage.getItem('username') ?? undefined;
    try {
      const resp = await axios.get(`${API_BASE}/journal/filter-options`, {
        params: {
          username,
          month: selectedMonth !== 'all' ? selectedMonth : undefined,
          pharmacyNum: selectedPharmacy ?? undefined,
          materialName: selectedProduct ?? undefined,
        },
      });
      if (resp.data?.success) setFilterOptions(resp.data.data);
    } catch (e) {
      console.error('Filter options fetch error:', e);
    } finally {
      setFilterOptionsLoading(false);
    }
  }, [selectedMonth, selectedPharmacy, selectedProduct]);

  return { filterOptions, filterOptionsLoading, fetchFilterOptions };
}
